import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';
import { BulkRefreshStatus } from '../types';

interface BulkRefreshBannerProps {
  status: BulkRefreshStatus | null;
}

const BulkRefreshBanner: React.FC<BulkRefreshBannerProps> = ({ status }) => {
  if (!status?.is_running) return null;

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-xl px-5 py-3 flex items-center gap-4">
      <CircularProgress size={18} thickness={5} className="text-blue-600" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-blue-800">
          Обновление снимков: {status.done}/{status.total} ({Math.round(status.progress_percent)}%)
        </p>
        {status.message && (
          <p className="text-xs text-blue-600 mt-0.5">{status.message}</p>
        )}
      </div>
      <div className="w-32 h-1.5 bg-blue-200 rounded-full overflow-hidden flex-shrink-0">
        <div
          className="h-full bg-blue-600 rounded-full transition-all duration-500"
          style={{ width: `${status.progress_percent}%` }}
        />
      </div>
    </div>
  );
};

export default BulkRefreshBanner;